export class ReportsAccesses {
    Id: number;
    AgentTypeId: number;
    ReportsTypesId: number;
}